import React, { Component } from "react";
import { Form, Row, Col, DatePicker } from "antd";
import moment from "moment";

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { data, dataInfo } = this.props;
    const { getFieldDecorator } = this.props.form;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };
    const dateFormat = "YYYY-MM-DD";
    return (
      <Row>
        <Col span={12}>
          <FormItem label="作废开始时间" {...ItemLayout}>
            {getFieldDecorator("beginDate", {
              rules: [{ required: true, message: "作废开始时间!" }],
              initialValue: data
                ? moment.unix(data.beginDate / 1000)
                : undefined,
            })(<DatePicker format={dateFormat} style={{ width: "100%" }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="作废终止时间" {...ItemLayout}>
            {getFieldDecorator("endDate", {
              rules: [{ required: true, message: "作废终止时间!" }],
              initialValue: data
                ? moment.unix(data.endDate / 1000)
                : moment.unix(dataInfo.endDate / 1000),
            })(<DatePicker format={dateFormat} style={{ width: "100%" }} />)}
          </FormItem>
        </Col>
      </Row>
    );
  }
}
export default BaseForm;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/end/FormTime.js